export const NAME = 'contact'
export const SET_FIELD = 'SET_CONTACT_FIELD'
export const SET_LOCKED = 'SET_CONTACT_LOCKED'
export const SET_SAVED = 'SET_CONTACT_SAVED'